module.exports = __webpack_public_path__ + "img/research-information-2.79a20a43.png";